import type { ParsedScoreAst } from '@interactive-room';
import type { MusicGenerationPrefs } from '@interactive-room';
import { resolveInteractiveRoomUrl } from '@interactive-room';

function resolveBaseUrl(baseUrl?: string): string {
  return resolveInteractiveRoomUrl(baseUrl);
}

function bufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}

export async function parseScoreUpload(
  file: File,
  baseUrl?: string,
  musicPrefs?: MusicGenerationPrefs,
): Promise<ParsedScoreAst> {
  const buffer = await file.arrayBuffer();
  const resp = await fetch(`${resolveBaseUrl(baseUrl)}/api/music/score/parse`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      fileName: file.name,
      data: bufferToBase64(buffer),
      musicPrefs,
    }),
  });
  const json = (await resp.json()) as { ok?: boolean; ast?: ParsedScoreAst; error?: string };
  if (!resp.ok || !json.ast) {
    throw new Error(json.error || 'score_parse_failed');
  }
  return json.ast;
}
